import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { SearchTagsParameters, TagClient, TagView } from './api-proxies';

@Injectable({
    providedIn: 'root'
})
export class TagService {
    constructor(private readonly client: TagClient) {}

    async search(body: SearchTagsParameters): Promise<TagView[]> {
        return await lastValueFrom(this.client.tagSearch(body));
    }

    async save(body: TagView): Promise<TagView> {
        return await lastValueFrom(this.client.tagSave(body));
    }
}
